import { ExtendedApartmentBuilding } from '@bpd-library/utilities';
import { useTranslate } from '@utilities/hooks';

import { StatusTranslations } from './status-translations';
import { FormattedStatus } from './types';

/**
 * @description Takes an Extended Apartment building and returns the correct color and translated label.
 * @param {ExtendedApartmentBuilding} apartmentBuilding
 *
 * @return {*}  {(FormattedStatus | undefined)}
 */
const formatApartmentBuildingStatus = (
    apartmentBuilding: ExtendedApartmentBuilding,
): FormattedStatus | undefined => {
    const { status, constructionNumbers, projectPhase } = apartmentBuilding;

    if (!status) return;

    switch (status) {
        case 'AmountAvailable':
            const availableConstructionNumbers = constructionNumbers!.filter(
                (s) => s.availabilityStatus === 'Available',
            );

            return {
                label: useTranslate('StatusLabel-AmountAvailable', {
                    replace: [{ id: 'Amount', value: `${availableConstructionNumbers.length}` }],
                }),
                color: 'green',
            };
        case 'AssigningOn':
            const allocationDate = new Date(projectPhase?.allocationDate!).toLocaleDateString(
                window.__ENVIRONMENT_DETAILS__.languageIsoCode,
                {
                    day: 'numeric',
                    month: 'short',
                },
            );

            return {
                label: useTranslate('StatusLabel-AssigningOn.Dynamic', {
                    replace: [{ id: 'Date', value: allocationDate }],
                }),
                color: 'orange',
            };
        default:
            return StatusTranslations.FORMATTED[status];
    }
};

export { formatApartmentBuildingStatus };
